import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'printTemplate',
    'calculatorContainer'
  ]

  handlePrint(event) {
    event.preventDefault()
    if (!this.hasPrintTemplateTarget) return

    const marketRatesContent = Array.from(this.printTemplateTarget.content.children).find(t => t.dataset.role === 'content').content.querySelector('.js-print-market-rates')
    const page1ContentHtml = printFunctions.getPage1Content(this.calculatorContainerTarget, marketRatesContent)
    const page2ContentHtml = printFunctions.getPage2Content(this.calculatorContainerTarget, marketRatesContent)
    const page3ContentHtml = printFunctions.getPage3Content(this.calculatorContainerTarget, marketRatesContent)
    const page4ContentHtml = printFunctions.getPage4Content(this.calculatorContainerTarget)

    const data = {
      pages: [
        {
          title: 'Vessel Comparison Report - Summary',
          content: page1ContentHtml
        },
        {
          title: 'Analysis - Index',
          content: page2ContentHtml
        },
        {
          title: 'Analysis - Speeds',
          content: page3ContentHtml
        },
        {
          title: 'Vessel Features',
          content: page4ContentHtml
        },
      ]
    }

    this.printTemplateTarget.dispatchEvent(new CustomEvent('print-template', { detail: data }))
  }
}

const printFunctions = (function () {

  function _toggleCollapseSections(sections, sectionsToShow) {
    sections.forEach(section => {
      const isSectionVisible = section.classList.contains('show')
      const isSectionToShow = sectionsToShow.some(sectionToShow => section.classList.contains(sectionToShow))
      if (isSectionVisible && !isSectionToShow) {
        section.classList.remove('show')
      } else if (!isSectionVisible && isSectionToShow) {
        section.classList.add('show')
      }
    })
  }

  function _showElements(container, elements) {
    _toggleElementsVisibility(container, elements, 'show')
  }

  function _hideElements(container, elements) {
    _toggleElementsVisibility(container, elements, 'hide')
  }
  function _toggleElementsVisibility(container, elements, action = 'show') {
    if (!container || !elements) return
    elements.forEach(className => {
      const elements = container.querySelectorAll(`.${className}`)
      Array.from(elements).forEach(element => {
        element.style.display = action === 'show' ? 'block' : 'none'
      })
    })
  }
  function _showOnlyFirst4Vessels(container) {
    if (!container) return container

    Array.from(container.querySelectorAll('.calc-vessel'))?.forEach((vessel, index) => {
      if ((index + 1) > 4) {
        vessel.remove()
      }
    })
  }

  function getPage1Content(calculatorContainer, marketRatesContent) {
    const page1Content = calculatorContainer.cloneNode(true)

    // toggle all calculator sections to show only the vessel particulars and speeds consumption
    const calculatorSections = page1Content.querySelectorAll('.calculator-section')
    const sectionsToShow = ['vessel-particulars', 'speeds-consumption']
    _toggleCollapseSections(calculatorSections, sectionsToShow)

    // show only the first 4 vessels
    _showOnlyFirst4Vessels(page1Content)

    _hideElements(page1Content, ['js-print-vessel-features', 'js-print-ghg', 'js-print-eexi'])

    return `
      <div class="calculator-print-page">
        ${page1Content.outerHTML}
        ${marketRatesContent.outerHTML}
      </div>
    `
  }

  function getPage2Content(calculatorContainer, marketRatesContent) {
    const page2Content = calculatorContainer.cloneNode(true)

    _showOnlyFirst4Vessels(page2Content)

    // expand VESSELINDEX® section
    const calculatorSections = page2Content.querySelectorAll('.calculator-section')
    const sectionsToShow = ['lr-index', 'lr-index-results', 'average-index']
    _toggleCollapseSections(calculatorSections, sectionsToShow)

    // Hide all other sections
    _hideElements(page2Content, ['js-print-vessel-particulars', 'js-print-vessel-features', 'js-print-speeds-consumption', 'button-sections', 'js-print-ghg', 'js-print-eexi'])

    return `
      <div class="calculator-print-page">
        ${page2Content.outerHTML}
        ${marketRatesContent.outerHTML}
      </div>
    `
  }
  function getPage3Content(calculatorContainer, marketRatesContent) {
    const page3Content = calculatorContainer.cloneNode(true)

    _showOnlyFirst4Vessels(page3Content)

    // expand VESSELINDEX® section
    const calculatorSections = page3Content.querySelectorAll('.calculator-section')
    const sectionsToShow = ['lr-index', 'lr-index-results', 'average-index']
    _toggleCollapseSections(calculatorSections, sectionsToShow)

    // hide voyages and show labels
    _hideElements(page3Content, ['voyages-labels', 'result-optispeed-voyages'])
    _showElements(page3Content, ['speed-labels', 'result-optispeed-speed'])

    // Hide all other sections
    _hideElements(page3Content, ['js-print-vessel-particulars', 'js-print-vessel-features', 'js-print-speeds-consumption', 'button-sections', 'js-print-ghg', 'js-print-eexi'])

    return `
      <div class="calculator-print-page">
        ${page3Content.outerHTML}
        ${marketRatesContent.outerHTML}
      </div>
    `
  }
  function getPage4Content(calculatorContainer) {
    const page4Content = calculatorContainer.cloneNode(true)

    _showOnlyFirst4Vessels(page4Content)

    // expand Vessel Features section
    const calculatorSections = page4Content.querySelectorAll('.calculator-section')
    const sectionsToShow = ['vessel-features']
    _toggleCollapseSections(calculatorSections, sectionsToShow)

    // Hide all other sections
    _hideElements(page4Content, [
      'js-print-vessel-particulars',
      'js-print-speeds-consumption',
      'button-sections',
      'js-print-vessel-index',
      'js-print-sisterships-index',
      'js-print-custom-index',
      'js-print-average-custom-index',
      'js-print-ghg',
      'js-print-eexi'
    ])

    return `
      <div class="calculator-print-page">
        ${page4Content.outerHTML}
      </div>
    `
  }

  return {
    getPage1Content,
    getPage2Content,
    getPage3Content,
    getPage4Content
  }
})()